<div class="wa-stack wa-gap-xl">
  @if (!survey()) {
    <wa-callout variant="warning">
      <wa-icon name="triangle-exclamation" slot="icon" variant="regular"></wa-icon>
      <strong>No valid semester has been selected.</strong><br/>
      Please <a href="/home">return to the main page</a> to select a valid semester first.
    </wa-callout>
  } @else {
    <div class="wa-heading-xl">Assignments for {{ survey()?.name }}</div>

    @if (survey()) {
      <app-statistics-panel
        [survey]="survey()!">
      </app-statistics-panel>
      <app-parameter-set-editor
        [survey]="survey()!"
        [user]="user">
      </app-parameter-set-editor>
    }
  }
</div>
